import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
// import {routesAd} from "@/router/adminRouter";
// import {routesSP} from "@/router/speciaRouter"
// import {routesS} from "@/router/studentRouter";
import {ElMessage} from "element-plus";
import Layout from "@/baseLayout/LayoutPage";
import {routesAd} from "@/router/adminRouter";
console.log("routesAd",routesAd)
const adminRole = "admin"
const adminGroupOne = "奖学金申请"
const adminGroupTwo = "奖学金评审"
const adminGroupThree = "基础信息"
const routes = [
  {
    path: "/",
    redirect:()=>{
      const role = store.getters['loginModel/getRole']
      if(role==="admin"){
        return {path:"/admin",replace:true}
      }else if(role==="special"){
        return {path:"/special",replace:true}
      }else if(role==="students"){
        return {path:"/student",replace:true}
      }else{ // 没有角色
        return {path:"/login",replace:true}
      }
    },
  },
  //  学生
  {
    path: "/student",
    name:"student",
    component:Layout,
    redirect:"/student/apply",
    children:[
      {
        path: 'apply',
        component: () => import(/* webpackChunkName: "about" */ '../views/students/ApplicationForm.vue'),
        meta:{title:"申请表",menuShow:true,role:"students"}
      },
      {
        path: 'applydetail',
        component: () => import(/* webpackChunkName: "about" */ '../views/students/ApplicationRecord.vue'),
        meta:{title:"申请记录",menuShow:true,role:"students"}
      },
    ]
  },
  //  专家
  {
    path: "/special",
    name:"special",
    component:Layout,
    redirect:"/special/judgelist",
    children:[
      {
        path: 'judgelist',
        component: () => import(/* webpackChunkName: "about" */ '../views/special/JudgeListView.vue'),
        meta:{title:"奖学金申请列表",menuShow:true,role:"special"}
      },
      {
        path: 'judgeDetail',
        component: () => import(/* webpackChunkName: "about" */ '../views/special/JudgeDetailView.vue'),
        meta:{title:"奖学金评分",menuShow:false,role:"special"}
      }
    ]
  },
  //  管理员
        routesAd,
  {
    path: "/admin",
    name:"admin",
    component:Layout,
    redirect:"/admin/applylist",
    children:[
      // 奖学金申请
      {
        path: 'applylist',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/ApplyListView.vue'),
        meta:{title:"申请列表",menuShow:true,"group":adminGroupOne,'role':adminRole}
      },
      {
        path: 'applydetail',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/ApplyDetailView.vue'),
        meta:{title:"申请详情",menuShow:false,"group":adminGroupOne,'role':adminRole}
      },
      //奖学金评审 todo
      {
        path: 'judgegroup',
        component: () =>import(/* webpackChunkName: "about" */ '../views/admin/JudgeGroupView.vue'),
        meta:{title:"分组管理",menuShow:true,"group":adminGroupTwo,'role':adminRole}
      },
      {
        path: 'Judgerule',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/JudgeRuleView.vue'),
        meta:{title:"打分标准",menuShow:true,"group":adminGroupTwo,'role':adminRole}
      },
      {
        path: 'JudgeResult',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/JudgeResultView.vue'),
        meta:{title:"评分结果",menuShow:true,"group":adminGroupTwo,'role':adminRole}
      },
// 基础信息
      //  申请人列表
      {
        path: 'students',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/StudentListView.vue'),
        meta:{title:"注册用户","group":adminGroupThree,menuShow:true,'role':adminRole}
      },
      {
        path: 'userlist',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/UserlistView.vue'),
        meta:{title:"账号管理",menuShow:true,"group":adminGroupThree,'role':adminRole}
      },
      {
        path: 'roles',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/RoleListView.vue'),
        meta:{title:"角色管理",menuShow:true,"group":adminGroupThree,'role':adminRole}
      }
    ]
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component:() =>  import(/* webpackChunkName: "about" */ '../views/LoginView.vue')
  },
  {
    path: '/:path(.*)',
    name: '404',
    meta: {},
    component: () => import(/* webpackChunkName: "about" */ '../views/ErrorPage/ErrorPage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  store.dispatch('showLoading'); // 显示 Loading
  // store.commit("loginModel/login",true)
  const isLogin = store.getters['loginModel/getLoginState'] // 是否登录
  const role = store.getters['loginModel/getRole'] // 获取用户角色
  console.log(isLogin,role)
  if (isLogin) { // 如果已经登录
    if(!role){ // 没有用户权限
      ElMessage.error('登录已过期，请重新登录')
      store.commit("loginModel/loginOut")
    }
    // 判断权限是否相符
    if(to.meta.role && (to.meta.role!==role)){ // 如果访问的带权限的页面，而且访问的页面不属于当前页面权限
      ElMessage.error('您无权访问当前页面')
      store.commit("loginModel/loginOut")
      return
      // return next({path:'/'})
    }
    // 判断是否是登录页面，如果进入的是登录页面，则进入到首页
    if (to.name === 'login') {
      // next({path:'/'}) // 如果已经登录了，跳转到登录页的时候，登录到首页
      if(role==="admin"){
        next({path:"/admin",replace:true})
      }else if(role==="special"){
        next({path:"/special",replace:true})
      }else if(role==="students"){
        next({path:"/student",replace:true})
      }
    } else {
      next()
    }
  } else { // 如果没登录，跳转到登录页面，登录页不显示进度条
    if (to.name === 'login') {
      next()
    } else {
      next({path: "/login"})
    }
  }
})
// 路由进入
router.afterEach(()=>{
  store.dispatch('hideLoading'); // 隐藏 Loading
})
export default router
